import {
  createSelectorCreator,
  lruMemoize,
} from 'reselect';
import { isEqual } from 'lodash';

export const createDeepEqualSelector = createSelectorCreator(
  lruMemoize,
  isEqual
);
